<template>
    <div class="ListKVAKod">
        <admin-lock-border />

        <h2>KVÅKoder</h2>

        <custom-action-table
            class="no-top"
            :selectableRows="false"
            :columns="tableColumns"
            :items="kvakoder"
            :actions="tableActions"
        >
        </custom-action-table>

        <pagination
            class="pagination mt-5"
            v-model="page"
            :per-page="100"
            :records="count"
            :options="paginationOptions"
            @paginate="paginate"
        />
    </div>
</template>

<script>
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import BaseTab from "@/tabs/mixins/BaseTab";
    import CustomActionTable from "@/components/generic/CustomActionTable.vue";
    import KVAKod from "@/tabs/Admin/KVAKod.vue";
    import Pagination from "vue-pagination-2";
    import PaginationTemplate from "@/components/widgets/PaginationTemplate.vue";
    import tabIcon from "@/assets/gear.svg";
    import { mapActions, mapGetters } from "vuex";

    const noNull = (str) => {
        return str || "";
    };

    const TABLE_COLUMNS = [
        {
            name: "code",
            title: "Kod",
            template: (item) => {
                return noNull(item.code);
            },
        },
        {
            name: "displayname",
            title: "DisplayName",
            template: (item) => {
                return noNull(item.displayName);
            },
        },
        {
            name: "klassdel",
            title: "Klassdel",
            template: (item) => {
                return noNull(item.klassdel ? "1" : "0");
            },
        },
        {
            name: "kapitel",
            title: "Kapitel",
            template: (item) => {
                return noNull(item.kapitel);
            },
        },
        {
            name: "avsnitt",
            title: "Avsnitt",
            template: (item) => {
                return noNull(item.avsnitt);
            },
        },
        {
            name: "valid_from_date",
            title: "Giltig från",
            template: (item) => {
                return noNull(item.valid_from_date);
            },
        },
        {
            name: "valid_to_date",
            title: "Giltig till",
            template: (item) => {
                return noNull(item.valid_to_date);
            },
        },
    ];

    const TABLE_ACTIONS = [
        {
            name: "edit",
            title: "Redigera",
            img: "edit.svg",
            condition: () => {
                return true;
            },
        },
    ];

    export default {
        extends: BaseTab,
        name: "ListKVAKod",
        tabName: "KVÅKoder",
        icon: tabIcon,
        components: {
            AdminLockBorder,
            CustomActionTable,
            Pagination,
        },
        props: ["tabId"],
        data() {
            return {
                tableColumns: TABLE_COLUMNS,
                tableActions: TABLE_ACTIONS,
                searchParameters: {},
                page: 1,
                paginationOptions: {
                    theme: "bootstrap4",
                    chunk: 10,
                    template: PaginationTemplate,
                    texts: {
                        count: "Visar {from} till {to} av {count} KVÅKod|{count} KVÅKoder|En KVÅkod",
                    },
                },
            };
        },
        computed: {
            ...mapGetters("kvakod", ["kvakoder", "count", "limit", "offset", "parameters"]),
        },
        methods: {
            ...mapActions("kvakod", ["load", "setOffset", "setParameters", "resetParameters"]),
            createKVAKod() {
                this.$store.dispatch("tabs/openTab", { component: KVAKod });
            },
            async paginate(page) {
                await this.$store.dispatch("tabs/displaySpinner", { id: this.tabId, display: true });
                this.setOffset(page * 100 - 100);
                await this.load();
                await this.$store.dispatch("tabs/displaySpinner", { id: this.tabId, display: false });
            },
        },
        async created() {
            await this.$store.dispatch("tabs/displaySpinner", { id: this.tabId, display: true });
            this.setOffset(0);
            this.setParameters(this.searchParameters);
            await this.load();
            await this.$store.dispatch("tabs/displaySpinner", { id: this.tabId, display: false });

            this.$on("edit", async (data) => {
                await this.$store.dispatch("tabs/openTab", { component: KVAKod, parameters: data });
            });
            this.$root.$on("saveOrEdit", () => {
                this.page = 1;
            });
        },
        beforeDestroy() {
            this.$store.commit("kvakod/reset");
        },
    };
</script>

<style lang="scss" scoped>
    .ListKVAKod {
        height: 100%;
    }
</style>
